import clsx from 'clsx';
import { CornerBadge } from '@src/components/CornerBadge';

interface BadgeGroupItem {
  label: string;
  bgColor: string;
}

interface BadgeGroupProps {
  badges: BadgeGroupItem[];
  className?: string;
  positionClassName?: string;
}

export function BadgeGroup({
  badges,
  className,
  positionClassName = 'absolute top-0 right-0',
}: Readonly<BadgeGroupProps>) {
  if (badges.length === 0) return null;

  return (
    <div className={clsx(positionClassName, 'flex overflow-hidden', className)}>
      {badges.map(({ label, bgColor }, index) => {
        const isFirst = index === 0;
        const isLast = index === badges.length - 1;
        const isSingle = badges.length === 1;

        const badgeClass = clsx(
          isSingle && 'rounded-tr-md rounded-bl-md',
          !isSingle && isFirst && 'rounded-bl-md',
          !isSingle && isLast && 'rounded-tr-md',
          !isFirst && !isLast && 'rounded-none'
        );

        return (
          <CornerBadge
            key={label}
            label={label}
            bgColor={bgColor}
            className={badgeClass}
          />
        );
      })}
    </div>
  );
}
